import React from "react";
import { Outlet } from "react-router-dom";
import CustomNavbar from "../header/NavBar";

function GlobalContentContainer(){
    return <div>
         <header>
          <CustomNavbar />
        </header>
        <Outlet/>
    </div>
}

export default GlobalContentContainer